import { Injectable, inject } from '@angular/core';
import {
  ToolingHistorySettings,
  ToolingHistorySettingsApi,
  toolingHistoryColumnsBaseConfig,
  toolingHistorySettingsDefaults,
} from './tooling-history-settings.api';
import { SettingsServiceBase } from 'src/services';
import { ToolingHistory } from './tooling-history.model';
import { configToSettingsColumnTitles } from '../config-utils';

@Injectable()
export class ToolingHistorySettingsService extends SettingsServiceBase<
  keyof ToolingHistory,
  ToolingHistorySettings,
  ToolingHistorySettingsApi
> {
  constructor() {
    const settingsApi = inject(ToolingHistorySettingsApi);

    super(
      settingsApi,
      configToSettingsColumnTitles(toolingHistoryColumnsBaseConfig),
      toolingHistorySettingsDefaults
    );
  }
}
